import { __rest, __assign } from 'tslib';
import React, { useMemo } from 'react';
import { useFormContext, useController, get } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { v4 } from 'uuid';
import { Button, selectedItemLabel, Field, Select as Select$1 } from '@panwds/react-ui';
import { requiredMessage } from '../../messages.esm.js';

/**
 * Renders a select connected to the form. All extra props will get passed to the select.
 */
var Select = function (props) {
    var _a, _b;
    var intl = useIntl();
    var _c = props.appearance, appearance = _c === void 0 ? "tertiary" : _c, _d = props.size, size = _d === void 0 ? "md" : _d, name = props.name, label = props.label, _e = props.register, register = _e === void 0 ? {} : _e, _f = props.defaultValue, defaultValue = _f === void 0 ? null : _f, description = props.description, tooltip = props.tooltip, disabled = props.disabled, showLabel = props.showLabel, _g = props.simpleFormat, simpleFormat = _g === void 0 ? false : _g, _h = props.placeholder, placeholder = _h === void 0 ? intl.formatMessage({ id: "SCclC5", defaultMessage: [{ type: 0, value: "Placeholder Text..." }] }) : _h, rest = __rest(props, ["appearance", "size", "name", "label", "register", "defaultValue", "description", "tooltip", "disabled", "showLabel", "simpleFormat", "placeholder"]);
    var labelId = useMemo(function () { return "field-".concat(v4(), "-label"); }, []);
    var buttonId = useMemo(function () { return "field-".concat(v4(), "-button"); }, []);
    var context = useFormContext();
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" && context === null) {
        throw new Error("Attempted to render Select outside of a Form context. Make sure your component is rendered inside <Form>.");
    }
    var formState = context.formState;
    register.required =
        (_a = register.required) !== null && _a !== void 0 ? _a : intl.formatMessage(requiredMessage, {
            label: label
        });
    var _j = useController({
        name: name,
        defaultValue: defaultValue,
        rules: register
    }).field, onChange = _j.onChange, ref = _j.ref, value = _j.value;
    var valueMap = useMemo(function () {
        return simpleFormat && !!rest.items
            ? rest.items.reduce(function (acc, curr) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a["".concat(curr.value)] = curr, _a)));
            }, {})
            : {};
    }, [rest.items, simpleFormat]);
    var selected = useMemo(function () {
        if (simpleFormat) {
            return rest.enableMultiSelect
                ? value === null || value === void 0 ? void 0 : value.map(function (value) { var _a; return (_a = valueMap[value]) !== null && _a !== void 0 ? _a : { value: value }; })
                : value && { value: value };
        }
        return value;
    }, [value, simpleFormat]);
    var DefaultButton = (React.createElement(Button, { addClassName: "tw-flex tw-justify-between", appearance: appearance, size: size, fullWidth: true, isMenu: true }, selectedItemLabel(selected) || placeholder));
    return (React.createElement(Field, { label: label, labelId: labelId, optional: !register.required, control: React.createElement(Select$1, __assign({ button: DefaultButton, fullWidth: true }, rest, { buttonRef: ref, labelId: labelId, toggleButtonId: buttonId, disabled: disabled, selectedItem: selected, onChange: function (changes) {
                return simpleFormat
                    ? onChange(rest.enableMultiSelect
                        ? changes.selectedItems.map(function (item) { return item.value; })
                        : changes.selectedItem.value)
                    : onChange(rest.enableMultiSelect
                        ? changes.selectedItems
                        : changes.selectedItem);
            } })), error: (_b = get(formState.errors, name)) === null || _b === void 0 ? void 0 : _b.message, description: description, tooltip: tooltip, disabled: disabled, showLabel: showLabel }));
};

export { Select };
//# sourceMappingURL=Select.esm.js.map
